import script from "./ContactDetails-back.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactDetails-back.vue?vue&type=script&setup=true&lang=ts"

import "./ContactDetails-back.vue?vue&type=style&index=0&id=1999c28e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1999c28e"]])

export default __exports__